import React from 'react';
import ModalBody from './ModalBody/Index';
import ModalHeader from './ModalHeader';

const ShareCollectionModal = ({ id, shareCollection }) => (
  <div
    className="modal fade"
    id="shareCollectionModal"
    tabIndex="-1"
    role="dialog"
    aria-labelledby="shareCollectionModal"
    aria-hidden="true"
  >
    <div
      className="modal-dialog modal-dialog-centered custom__modal__filter"
      role="document"
    >
      <div className="modal-content">
        <div className="custom__modal__content">
          <ModalHeader />
          <ModalBody id={id} shareCollection={shareCollection} />
        </div>
      </div>
    </div>
  </div>
);

export default ShareCollectionModal;
